var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EnrollmentsEditTabAccount',{staticClass:"pt-75",on:{"changed-query":_vm.fetchEnrollmentsData}})}
var staticRenderFns = []

export { render, staticRenderFns }